import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useStringsContext } from '../../../../../contexts/strings';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import SceneHeader from '../../../../common/scene/scene-header';
import Grid2 from '@mui/material/Grid2';
import { FormControl, InputLabel } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface Props {
  seasons: number[];
  loading: boolean;
  disableAddPlayer: boolean;
  onShowAddplayer: () => void;
  onSelectSeason: (value: number) => void;
  onUploadSquadImages: () => void;
  selectedSeason: number;
  isReadOnly?: boolean;
}

function SquadOverviewHeader({
  seasons,
  loading,
  disableAddPlayer,
  onShowAddplayer,
  onSelectSeason,
  onUploadSquadImages,
  selectedSeason,
  isReadOnly,
}: Props) {
  const { strings } = useStringsContext();

  return (
    <SceneHeader title={`${strings.squad.squad} ${selectedSeason}`}>
      <FormControl>
        <InputLabel size="small">{strings.squad.season}</InputLabel>
        <Select
          size="small"
          value={selectedSeason.toString()}
          onChange={(e: SelectChangeEvent) => {
            onSelectSeason(parseInt(e.target.value as string, 10));
          }}
          label={strings.squad.season}
        >
          {seasons.map((season) => (
            <MenuItem key={season.toString()} value={season}>
              {season}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Grid2 container spacing={2}>
        <Grid2>
          <Button
            variant="contained"
            onClick={() => onUploadSquadImages()}
            startIcon={<CloudUploadIcon />}
            disabled={disableAddPlayer || isReadOnly}
          >
            {strings.squad.uploadSquadImages}
          </Button>
        </Grid2>
        <Grid2>
          <LoadingButton
            variant="contained"
            loading={loading}
            onClick={() => onShowAddplayer()}
            startIcon={<AddIcon />}
            disabled={disableAddPlayer || isReadOnly}
          >
            {strings.squad.addPlayer || isReadOnly}
          </LoadingButton>
        </Grid2>
      </Grid2>
    </SceneHeader>
  );
}

export default SquadOverviewHeader;
